import React from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import './style.css'

const CSSListItemTransition = (props) => {
  return (
    <ReactCSSTransitionGroup
      transitionName="list-transition"
      transitionAppear={true}
      transitionAppearTimeout={300}
      transitionEnterTimeout={500}
      transitionLeaveTimeout={500}>
      {props.children}
    </ReactCSSTransitionGroup>
  )
}

export default CSSListItemTransition



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CSSListItemTransition/index.js